/*
 * @Author: ken yang
 * @Date: 2021-11-25 17:30:48
 * @LastEditTime: 2022-08-18 14:09:37
 * @LastEditors: ken yang
 * @Description: 注册全局组件
 * @FilePath: \nicee-h5\src\components-new\index.js
 */
import uploader from '@/components-new/uploader'

class Com {}
Com.install = (_Vue) => {
  _Vue.component('uploader', uploader)
}
export default Com
